import { Redirect, Route, Switch } from "react-router-dom";

import BrandPage from "../../pages/brand/BrandPage";
import CommissionPage from "../../pages/commission/CommissionPage";
import CustomerPage from "../../pages/customer/CustomerPage";
import InquiryPage from "../../pages/inquiry/InquiryPage";
import InsightPage from "../../pages/insight/InsightPage";
import LdasPage from "../../pages/ldas/LdasPage";
import MainPage from "../../pages/MainPage";
import MemberManagePage from "../../pages/memberManage/MemberManagePage";
import NutrientsPage from "../../pages/nutrients/NutrientsPage";
import ProductPage from "../../pages/product/ProductPage";
import PromotionMainPage from "../../pages/promotion/PromotionMainPage";
import SalesManagePage from "../../pages/salesManage/SalesManagePage";
import StatisticsPage from "../../pages/statistics/StatisticsPage";

const ContentComponent = () => {
  return (
    <Switch>
      {/*<Route exact path="/" component={MainPage}/>*/}
      <Route exact path="/" component={MainPage} />
      {/*<Route exact path="/backup" component={MainPageBackup}/>*/}
      <Route path="/customer" component={CustomerPage} />
      <Route path="/product" component={ProductPage} />
      <Route path="/salesManage" component={SalesManagePage} />
      <Route path="/inquiries" component={InquiryPage} />
      <Route path="/promotion" component={PromotionMainPage} />
      <Route path="/content" component={PromotionMainPage} />
      <Route path="/memberManage" component={MemberManagePage} />
      <Route path="/nutrients" component={NutrientsPage} />
      <Route path="/insight" component={InsightPage} />
      <Route path="/commission" component={CommissionPage} />
      <Route path="/statistics" component={StatisticsPage} />
      <Route path="/brand" component={BrandPage} />
      <Route path="/ldas" component={LdasPage} />
      <Route path="*">
        <Redirect to={`/`} />
      </Route>
    </Switch>
  );
};

export default ContentComponent;
